import { render, staticRenderFns } from "./HoroscopeButton.vue?vue&type=template&id=1166e5bf&scoped=true&"
import script from "./HoroscopeButton.vue?vue&type=script&lang=js&"
export * from "./HoroscopeButton.vue?vue&type=script&lang=js&"
import style0 from "./HoroscopeButton.vue?vue&type=style&index=0&id=1166e5bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1166e5bf",
  null
  
)

export default component.exports